import Carousel from '../components/Carousel';
import Slider from '../components/Slider';
import { $ } from '../util/DOM';

const getLinkHtml = (el) => {
  const qs = el.getAttribute('data-link-content');
  if (!qs) {
    return '';
  }
  const content = el.querySelector(qs);
  if (!content) {
    return '';
  }
  return content.innerHTML;
};

const sliderControlComponents = {
  arrows: (slider) => $.render('div', {
    className: 'slider-controls__arrows',
    children: [
      $.render('button', {
        type: 'button',
        className: 'prev',
        attrs: { 'aria-label': 'Voltar slide' },
        innerHTML: /* html */ `
        <svg width="9" height="18" viewBox="0 0 9 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.6001 16.9145C8.59987 16.6258 8.49562 16.3491 8.31028 16.1451L3.25688 10.5766C3.10392 10.4081 2.98258 10.208 2.8998 9.98785C2.81702 9.76767 2.77441 9.53167 2.77441 9.29334C2.77441 9.05501 2.81702 8.81901 2.8998 8.59883C2.98258 8.37864 3.10392 8.17859 3.25688 8.01008L8.30369 2.44519C8.48367 2.23985 8.58325 1.96484 8.581 1.67937C8.57875 1.39391 8.47484 1.12084 8.29166 0.918981C8.10847 0.717121 7.86066 0.602619 7.6016 0.600139C7.34255 0.597658 7.09297 0.707397 6.90663 0.905719L1.85981 6.46626C1.18122 7.2155 0.800097 8.2308 0.800097 9.28935C0.800097 10.3479 1.18122 11.3632 1.85981 12.1124L6.91321 17.681C7.0512 17.8331 7.22698 17.9368 7.41839 17.979C7.6098 18.0211 7.80826 17.9999 7.98872 17.9179C8.16918 17.8359 8.32355 17.6968 8.43236 17.5183C8.54117 17.3397 8.59954 17.1296 8.6001 16.9145Z" fill="#A4C736"/>
        </svg>
        `,
        events: {
          click: () => {
            slider.goPrev();
          },
        },
      }),
      $.render('button', {
        type: 'button',
        className: 'next',
        attrs: { 'aria-label': 'Avançar slide' },
        innerHTML: /* html */ `
        <svg width="9" height="18" viewBox="0 0 9 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.600098 16.3144C0.600328 16.0257 0.704574 15.749 0.889917 15.545L5.94332 9.9765C6.09628 9.80799 6.21761 9.60794 6.30039 9.38775C6.38317 9.16757 6.42578 8.93157 6.42578 8.69324C6.42578 8.45491 6.38317 8.21891 6.30039 7.99873C6.21761 7.77855 6.09628 7.57849 5.94332 7.40999L0.896504 1.84509C0.716528 1.63976 0.616941 1.36474 0.619192 1.07928C0.621443 0.793812 0.725353 0.520744 0.90854 0.318883C1.09173 0.117023 1.33954 0.00252175 1.59859 4.11571e-05C1.85765 -0.00243944 2.10722 0.107299 2.29357 0.305621L7.34038 5.86616C8.01898 6.6154 8.4001 7.6307 8.4001 8.68925C8.4001 9.7478 8.01898 10.7631 7.34038 11.5123L2.28698 17.0809C2.149 17.233 1.97321 17.3367 1.7818 17.3789C1.59039 17.421 1.39194 17.3998 1.21148 17.3178C1.03102 17.2358 0.876645 17.0967 0.767836 16.9182C0.659027 16.7396 0.600659 16.5295 0.600098 16.3144Z" fill="#A4C736"/>
        </svg>`,
        events: {
          click: () => {
            slider.goNext();
          },
        },
      }),
    ],
  }),
  counters: (slider) => {
    const children = slider.children.map((el, i) => $.render('button', {
      type: 'button',
      textContent: i + 1,
      attrs: { 'aria-label': `Ver o slide ${i + 1}` },
      events: { click: () => slider.goTo(i) },
    }));

    slider.on('render', () => {
      children.forEach((btn, btnIndex) => {
        if (btnIndex === slider.index) {
          btn.classList.add('is-active');
        } else {
          btn.classList.remove('is-active');
        }
      });
    });

    return $.render('div', {
      className: 'slider-controls__counters',
      children,
    });
  },
  links: (slider) => {
    const children = slider.children.map((el, i) => $.render('div', {
      innerHTML: getLinkHtml(el),
      tabindex: '-1',
      events: { click: () => slider.goTo(i) },
    }));

    slider.on('render', () => {
      children.forEach((btn, btnIndex) => {
        if (btnIndex === slider.index) {
          btn.classList.add('is-active');
        } else {
          btn.classList.remove('is-active');
        }
      });
    });

    return $.render('div', {
      className: 'slider-controls__links',
      children,
    });
  },
};

const generateControls = (slider, keys) => keys.map((key) => {
  if (!(key in sliderControlComponents)) {
    // eslint-disable-next-line no-console
    console.warn(`Opção de controle inválida: ${key}. As opções disponíveis são ${
      Object.keys(sliderControlComponents).join(', ')
    }`);
    return null;
  }
  return sliderControlComponents[key](slider);
});

const setSliderControls = (slider, controlOptions) => {
  if (!controlOptions) {
    return;
  }
  const controlKeys = controlOptions.trim().split(' ');
  if (!controlKeys.length) {
    return;
  }

  const container = $.render('div', {
    className: 'slider-controls__container',
    children: generateControls(slider, controlKeys),
  });

  slider.container.insertAdjacentElement('afterEnd', container);
};

const createSlider = (container, type) => {
  const play = container.hasAttribute('data-play');
  const interval = container.getAttribute('data-interval') || 3000;
  const height = container.getAttribute('data-height');
  const controls = container.getAttribute('data-controls');

  const slider = (
    type === 'carousel'
      ? new Carousel(container, { interval })
      : new Slider(container, { interval })
  );

  if (play) {
    slider
      .on('mouseover', () => slider.pause())
      .on('mouseout', () => slider.play())
      .play();
  }

  if (height) {
    slider.container.style.height = height;
  }

  if (controls) {
    setSliderControls(slider, controls);
  }

  return slider;
};

const createCarousel = (container) => {
  createSlider(container, 'carousel');
};

const initSliders = () => {
  $('.slider').forEach(createSlider);
  $('.carousel').forEach(createCarousel);
};

export default initSliders;
